export default __webpack_public_path__ + "static/media/cartIcon.77dfa07b.svg";